export default "__VITE_ASSET__b1467cf4__"